import React, { useState } from "react";
import EdModal from "./edModal";

export const StaticPopup = (props: any) => {
    const [showPopup, setShowPopup] = useState(true);
    const ifscpopup = () => {
        return (
        <>
            <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal staticPopupWidth ">
              <div className="modal-content">
                <div className="modal-body scrollableModal" id="custom_scrollBar">
                  <div className="finalScreen consentPopup searchCodeIfsc">
                    <span
                        role="button"
                        title="Close"
                        className="cancel"
                        onClick={() => {
                            setShowPopup(false);
                            props.ShowPopup(false);
                        }}
                        >
                        <i className="edel-icon-close"></i>
                    </span>
                  </div>
                  <div className="finalScreen consentPopup searchCodeIfsc">                    
                    <div>
                        <h2 className="field-head text-center mg-t12">{ props.heading }</h2>
                    </div>
                    <div>
                    <div className="finalScreen consentPopup ">
                        <div className="reactivateSteps width-100 ">
                        <ul>
                        {props.content.map((content:string) => {
                            return ( 
                                <li className="bullet_lists">
                                  <div>
                                    <div className="link_arrow">
                                      <i className="edel-icon-right-arrow"></i>
                                    </div>
                                  </div>
                                  <span 
                                    dangerouslySetInnerHTML={{
                                      __html: content,
                                  }}/>
                                </li>                              
                                
                            );
                        })}
                        </ul>
                        </div>
                    </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <a className="bold-text link-text"
                    onClick={(e: any) => {
                        e.preventDefault();
                        setShowPopup(false);
                        props.ShowPopup(false);
                    }}
                    > OK </a>
                  </div>
                </div>
              </div>
            </div>
            
        </>
        );
    };
  
    return (
        <>
        <EdModal show={showPopup} close={() => {}} children={ifscpopup()} />
        </>
    );
};
